export default __webpack_public_path__ + "static/club-voyages-banner-mobile-72328d4235afc273c6657e7e3f10d64a.webp";